export const subscription = {
  subscriptions: '订阅',
  plan: '计划',
  whatsappPlan: 'WhatsApp计划',
  addOns: '附加服务',
  billingDetails: '账单详情',
  invoices: '发票',
  wa1Reminder: 'WA第一提醒',
  wa2Reminder: 'WA第二提醒',
  waRenewApi: 'WA续费API',
  waCheckUsageApi: 'WA检查使用API',
  waResetUsageApi: 'WA重置使用API',
  waExceedUsageApi: 'WA超过使用API',
  waGetBotsInThisAccount: 'WA获取此账户中的机器人',
  appTooltip: {
    TOOLTIP_PLAN_HEADING: '我们为您的所有需求提供最实惠的价格。',
    TOOLTIP_WHATSAPP_PLAN_HEADING: 'WhatsApp计划',
    TOOLTIP_ADDS_ON_HEADING: '购买额外的消息包和白标机器人',
    TOOLTIP_ADDS_ON_MESSAGE: '如果您已达到每月消息限制，您可以购买额外的包。',
    TOOLTIP_SUBSCRIPTION_HEADING: '检查您当前的订阅详情',
    TOOLTIP_HORIZONTAL_BAR: '通过将条形左右移动，查看我们每月或每年的价格从3K到500K条消息。',
    TOOLTIP_BILLING_ADDRESS_HEADING: '更新您的账单详情以进行发票。',
    TOOLTIP_INVOICES_HEADING: '查看您之前的发票。',
    TOOLTIP_INVOICES_ACTION: '单击以在您的电子邮件账户中接收发票'
  },
  currentPlan: {
    seeHowToUse: '了解如何使用',
    help: '帮助',
    downgradeRequest1: '您已提出将您的计划降级到',
    downgradeRequest2: '条消息的请求。请注意，您的计划将在当前计费周期结束时降级',
    downgradeRequest3: '在那之前，您可以享受',
    downgradeRequest4: '的服务。',
    downgradeRequestMaster1: '您已提出将您的',
    downgradeRequestMaster2: '计划降级到',
    downgradeRequestMaster3: '条对话的请求。请注意，您的计划将在当前计费周期结束时降级',
    downgradeRequestMaster4: '在那之前，您可以享受',
    downgradeRequestMaster5: '的服务。',
    active: '活跃',
    inactive: '非活跃',
    month: '月',
    year: '年',
    messagePack: '消息包',
    king: '高级',
    baby: '初级',
    whatsapp: 'WhatsApp',
    youAreOn: '您目前使用的是',
    plan: '计划',
    totalMessagesLimit: '总消息限制',
    liveAgentLimit: '在线客服限制',
    perMonth: '/月',
    agents: '个坐席',
    messagesAddOn: '消息附加服务',
    botWhitelabels: '机器人白标',
    totalAddOnMessages: '总附加消息',
    basePrice: '基本价格',
    gst: '消费税',
    totalPrice: '总价格',
    totalAddOnPrice: '总附加价格',
    whitelabelPrice: '白标价格',
    startedOn: '开始时间',
    nextDueOn: '下次到期时间',
    addOnExpiry: '附加服务到期时间',
    website: '网站',
    facebook: 'Facebook',
    telegram: 'Telegram',
  },
  invoice: {
    invoiceNumber: '发票号',
    date: '日期',
    invoiceAmount: '发票金额',
    planAmount: '计划金额',
    plan: '计划',
    messages: '消息',
    action: '操作',
    nA: '不适用',
    appTooltip: {
      clickToReceiveInvoiceInYourEmailAccount: '单击以在您的电子邮件账户中接收发票',
      clickToDownloadInvoice: '单击以下载PDF格式的发票',
    }
  },
  messageAddOn: {
    validity: '有效期',
    kingPlanHeader: '👑 高级计划',
    youAreOnThe: '您目前使用的是',
    asOfNowAndWillGet: '截至目前，您将获得',
    messages: '条消息',
    inThisPlan: '在此计划中。',
    youCanBuyAdditionalMessaes: '您可以根据业务需求购买额外的消息。',
    plan: ' 计划',
    baby: '初级',
    king: '高级',
    get: '获取',
    babyPlan: '初级计划',
    upgradePlan: '升级计划',
    asOfNow: ' 截至目前。',
    pleaseUpgradeToKingPlan: '请升级到',
    toEnableAddOnsAndWhitelabelPacks: '以启用附加服务和白标机器人。',
    messageAddOnPacks: '消息附加服务包',
    ifYouHaveReachedYourMonthlyMessageLimit: '如果您已达到每月消息限制，请购买额外的包并享受不间断的服务。',
    pleaseSelectNumberOfExpectedMessages: '请选择预期消息数',
    addOnsValidity: '附加服务有效期',
    currentBillingCycle: '当前计费周期',
    oneYear: '一年',
    summary: '摘要',
    messageCreditsWithKingPlan: '高级计划的消息额度',
    messageCreditsWith: '的消息额度',
    withPlan: '计划',
    billingCycle: '计费周期',
    payableAmount: '应付金额',
    oneTimePayment: '一次性付款',
    plusTaxes: ' + 税收',
    buyNow: '立即购买',
    whiteLabelChatWindow: '白标聊天窗口',
    noBotsLeftToWhiteLabel: '没有可用于白标的机器人。',
    pleaseSelectTheBotsYouWantToWhiteLabel: '请选择要白标的机器人。',
    selectBots: '选择机器人',
    bot: '机器人',
    bots: '机器人',
    toBeWhiteLabelled: ' 将被白标',
    remove: '移除',
    brandNameFromChatWindow: '从聊天窗口中移除品牌名称。',
    willBeValidTill: '将在有效期截止日期之前有效',
    ourYearlyPrice: '我们的年费价格',
    directWhiteLabel: '直接白标',
    whiteLabelledBots: '已白标机器人',
    nextRenewalColon: '下次续费：',
    optOutRequested: '已请求退出',
    contactAgency: '联系机构',
    optOut: '退出',
    removeWhiteLabel: '移除白标',
    messageCount: '消息数量',
    numberOfPacks: '包数量',
    amount: '金额',
    taxes: '税收',
    totalAmount: '总金额',
    numOfBots: '机器人数量',
    select: '选择',
    selectTheValidity: '选择有效期',
  },
  payment: {
  },
  paymentMethod: {
    paymentDetails: '付款详情',
    cardNumber: '卡号 ',
    cvv: 'CVV ',
    month: '月',
    year: '年',
    save: '保存',
    add: '添加',
    edit: '编辑',
    disclaimer: '免责声明： ',
    disclaimerDescription1: '以上付款方式仅适用于印度以外的用户。',
    disclaimerDescription2: '我们不会保存您的卡详细信息。' +
      '如果您想更改您的卡详细信息，将直接在支付网关上更改。',
    billingAddress: '账单地址',
    companyName: '公司名称 ',
    country: '国家 ',
    selectCountry: '选择国家',
    stateOrRegion: '州/地区 ',
    streetAddress: '街道地址 ',
    gstIn: 'GSTIN ',
    postalCode: '邮政编码 ',
    cancel: '取消',
    proceedToPay: '继续支付',
    company: '公司',
    state: '州',
    masterCard: '万事达卡',
    yourCompanyName: '您的公司名称',
    yourCountry: '您的国家',
    yourRegion: '您的州/地区',
    yourPostalCode: '您的邮政编码',
    plusTaxes: ' + 税收',
    dropDown: {
      month: '月 *',
      year: '年 *',
    },
    placeholders: {
      enterCardNumber: '输入卡号',
      cvv: 'CVV',
      enterYourCompanyName: '输入您的公司名称',
      enterYourStateOrRegion: '输入您的州/地区',
      enterYourStreetAddress: '输入您的街道地址',
      enterYourGSTIN: '输入您的GSTIN',
      enterPostalCode: '输入邮政编码',
    }
  },
  plans: {
    viewDetailedPricing: '查看详细价格',
    seeHowToUse: '查看如何使用',
    help: '帮助',
    weHaveGotAPricingPlanPerfectForYou: '我们有一个完全适合您的定价计划',
    weBelieve: '我们相信',
    shouldBeAccessibleToAllCompanies: ' 应该对所有公司都是可访问的，无论其规模如何。',
    monthly: '每月',
    yearly: '每年',
    twoMonthsFree: '（2个月免费）',
    babyPlan: '基础计划',
    freeForever: '永久免费',
    messagesPerMonth: '每月消息数',
    currentPlan: '当前计划',
    freePlan: '免费计划',
    kingPlan: '高级计划',
    perYear: '每年',
    plan: '计划',
    toThe: ' 到',
    plusTaxes: ' + 税',
    perMonth: '每月',
    upgradePlan: '升级计划',
    changePlan: '更改计划',
    currentlyActive: '当前活动',
    emperorPlan: '皇帝计划（企业版）',
    sendAsManyMessagesAsYouWant: '发送您需要的消息',
    contactUs: '联系我们',
    features: '特点',
    areYouSureYouWantToShiftFrom: '您确定要从',
    messages: '消息',
    planQuestionMark: '计划 切换吗？',
    downgradeToFreePlan: '降级到免费计划',
    goToBabyPlan: '切换到基础计划',
    thankYouForChoosingBotPenguin: '感谢您选择BotPenguin',
    bots: '机器人',
    facebookPages: 'Facebook页面',
    teamMember: '团队成员',
    dataStorage: '数据存储',
    conditionalFlow: '条件流',
    liveChat: '在线聊天',
    bookAppointments: '预约',
    csvExport: 'CSV导出',
    emailAndCallSupport: '电子邮件和呼叫支持',
    googleCalendarIntegrations: 'Google日历集成',
    zohoCrmIntegrations: 'Zoho CRM集成',
    reportsAndAnalytics: '报告和分析',
    removeBotPenguinBranding: '去除BotPenguin品牌',
    oneBot: '1个机器人',
    twoKMessagesPerMonth: '每月2千条消息',
    oneFacebookPage: '1个Facebook页面',
    oneTeamMember: '1个团队成员',
    thirtyDaysOfDataStorage: '30天的数据存储',
    unlimitedBot: '无限机器人',
    threeTo500kMessagesPerMonth: '每月3千至50万条消息',
    tenFacebookPages: '10个Facebook页面',
    threeTeamMembers: '3个团队成员',
    nintyDaysOfDataStorage: '90天的数据存储',
    unlimitedMessages: '无限消息',
    unlimitedFacebookPages: '无限Facebook页面',
    unlimitedTeamMembers: '无限团队成员',
    unlimitedDataStorage: '无限数据存储',
    youAreHere: '您在这里！',
    detailedPricing: {
      kingsplan: 'King计划',
      elementary: '初级',
      solutionType: '解决方案类型',
      saas: 'SaaS',
      fbpage1fb: '1 FB页面',
      perMonth100: '每月100',
      enterprise: '企业版',
      saasOnPremises: 'SaaS On Premises',
      aiChatbotFeatures: 'AI Chatbot功能',
      dataSourceForTraning: '培训数据来源',
      smartFeatures: '智能功能',
      liveChat: '实时聊天',
      day30: '30天',
      day90: '90天',
      landSquared: 'Landsquared',
      doItYourself: '自己动手',
      unifiedInbox: '统一收件箱',
      platforms: '平台',
      websiteChatbot: '网站Chatbot',
      FacebookMessengerChatbot: 'Facebook Messenger Chatbot',
      Telegram: 'Telegram',
      conversationalLandingPage: '对话式着陆页',
      integrations: '集成',
      reportsAndAnalytics: '报告和分析',
      customerSupport: '客户支持',
      security: '安全',
      bots: '机器人',
      babyPlan: '基础计划',
      kingPlan: 'King计划',
      emperorPlan: 'Emperor计划',
      noofBots: '机器人数量',
      one: '1（一个）',
      unlimitedBots: '无限机器人',
      noOfWebsite: '网站数量',
      unlimitedWebsites: '无限网站',
      unlimitedMessages: '无限消息',
      messagesSend: '发送消息',
      perMonth2000: '每月2,000',
      upto500000perMonth: '每月最多500,000',
      facebookMessenger: 'Facebook Messenger',
      unlimitedPages: '无限页面',
      telegramNumbers: 'Telegram号码',
      unlimited: '无限',
      whatsappNumbers: 'WhatsApp号码',
      subscribersLeads: '订阅者/潜在客户',
      createSupportTeam: '为实时聊天创建支持团队',
      oneMember: '1成员',
      threeMembers: '3成员',
      conversationHistory: '对话历史',
      thirtyDays: '30天',
      ninetyDays: '90天',
      chatbotDesigning: 'Chatbot设计',
      weAreHereToHelp: '我们在这里帮助您',
      weTakeCareEndToEnd: '我们负责从头到尾',
      multipleLanguages: '多语言',
      conditionalFlow: '条件流',
      removeBotPenguinBranding: '去除BotPenguin品牌',
      gptMessages: 'GPT消息',
      aiChatbot: 'AI Chatbot',
      chatGPTIntegration: 'ChatGPT集成',
      configureAIChatbotPersonality: '配置AI Chatbot个性',
      trainChatbotOnYourOwnData: '使用您自己的数据训练Chatbot',
      trainChatbotOnWebPages: '在网页上训练Chatbot',
      trainChatbotOnMultipleFiles: '在多个文件上训练Chatbot',
      trainChatbotOnFAQs: '在FAQ上训练Chatbot',
      dataTrainingStorage: '数据培训存储',
      useChatGPTModel4_3_5Turbo: '使用ChatGPT Model 4/3.5 Turbo',
      uploadMultipleFilesForChatbotTraining: '上传多个文件进行Chatbot培训',
      naturalLanguageProcessing: '自然语言处理',
      naturalLanguageUnderstanding: '自然语言理解',
      answerLength: '答案长度',
      chatTone: '聊天语气',
      multiLanguage: '多语言',
      answerFormatting: '答案格式',
      customPrompt: '自定义提示',
      integrateBotPenguinLLM: '集成BotPenguin LLM',
      integrateOwnCustomLLM: '集成自有/定制LLM',
      periodicallySyncDataSources: '定期同步数据源',
      aiBasedSuggestedQuestions: '基于AI的建议问题',
      chooseVisibilityForParticularWebpageSitemap: '选择特定网页/站点地图的可见性',
      chooseKnowledgeMix: '选择知识混合：\n您的知识库\nChatGPT知识\n"ChatGPT知识 + 您的知识库"',
      faqExtractionFromFileAndURL: '从文件和URL提取FAQ',
      analyticsToImproveAI: '改善AI的分析',
      exportQuestionFlow: '导出问题流',
      sessionManagement: '会话管理',
      collectFeedbackOnChatbotResponses: '收集Chatbot响应的反馈',
      smartAIFollowUpQuestions: '智能/AI后续问题',
      trainOnYourNotionWorkspaceData: '在您的Notion工作区数据上训练',
      trainOnYoutubeVideo: '在YouTube视频上训练',
      trainOnCustomVideoUpload: '在自定义视频上传上训练',
      rssFeed: 'RSS Feed',
      googleDrive: 'Google Drive',
      dropBox: 'DropBox',
      ipAndRegionBlocking: 'IP和区域阻止',
      emailAndMobileValidation: '电子邮件和手机号验证',
      appointmentsBooking: '预约预订',
      humanHandover: '人工移交',
      botHandover: 'Bot移交',
      handoverBetweenAgents: '代理之间的移交',
      mobileAppsForAgents: '代理的移动应用',
      roleBasedAccessControls: '基于角色的访问控制',
      apiIntegrationOnChatFlows: 'Chat Flows的API集成',
      liveChatWidget: '实时聊天小部件',
      typingIndicator: '输入指示器',
      liveVisitorsDetails: '实时访客详情',
      multipleSimultaneousChat: '多个同时聊天',
      liveTypingView: '实时输入视图',
      ruleBasedChatRouting: '基于规则的聊天路由',
      chatAutoAssignments: 'Chat自动分配',
      efficientOmnichannelInterface: '高效的全渠道界面',
      quickReplies: '快速回复',
      unifiedCustomerProfile: '统一的客户概要',
      visitorStats: '访客统计',
      addContactsFromWhatsapp: '从WhatsApp添加联系人',
      applyFilterAndSortConversations: '应用筛选器并对对话进行排序',
      seeChatLogs: '查看聊天记录',
      assignNotesAndChatTags: '分配注释和聊天标签',
      directCallsToLeadsWithTwilio: '通过Twilio直接呼叫到潜在客户',
      customerSegmentation: '客户细分',
      exportLeadsInCSV: '以CSV格式导出潜在客户',
      leadNotificationsByEmail: '通过电子邮件发送潜在客户通知',
      website: '网站',
      wordPress: 'WordPress',
      whatsApp: 'WhatsApp',
      facebook: 'Facebook',
      telegram: 'Telegram',
      shopify: 'Shopify',
      autoTriggeringOnMobileDesktop: '在移动/桌面上自动触发',
      hideBotOnSpecificPages: '在特定页面上隐藏机器人',
      imageSharing: '图像分享',
      readyToUseChatFlowTemplates: '可用于Chat Flow的模板',
      fileSharing: '文件分享',
      customDesignForChatWindow: 'Chat窗口的自定义设计',
      facebookMessengerBot: 'Facebook Messenger Bot',
      facebookSubheading: 'Facebook副标题',
      telegramSubheading: 'Telegram副标题',
      conversationalLangdingPageSubheading: '对话式着陆页副标题',
      integrationsSubheading: '集成副标题',
      multipleSmartFlows: '多个智能流',
      dripCampaigns: '滴漏活动',
      broadcastFBMessages: '广播FB消息',
      multipleFacebookBotWidgets: '多个Facebook Bot小部件',
      facebookAutoReplyOnComments: 'Facebook评论上的自动回复',
      facebookECommerce: 'Facebook电子商务',
      broadcastAnalytics: '广播分析',
      telegramMessengerBot: 'Telegram Messenger Bot',
      readyToUseTemplates: '可用模板',
      groupBroadcastTelegramMessages: '组和广播Telegram消息',
      multipleTelegramBotWidgets: '多个Telegram Bot小部件',
      conversationalLandingPageBot: '对话式着陆页Bot',
      smartReplies: '智能回复',
      interactiveAndCustomizableUI: '交互式和可定制的UI',
      leadManagement: '潜在客户管理',
      easyToInstallAndShare: '易于安装和分享',
      agileCRM: 'Agile CRM',
      capsule: 'Capsule',
      insightly: 'Insightly',
      nimble: 'Nimble',
      leadsquared: 'Leadsquared',
      chakra: 'Chakra',
      plivo: 'Plivo',
      helpcrunch: 'Helpcrunch',
      getresponse: 'Getresponse',
      supportbee: 'Supportbee',
      pipeline: 'Pipeline',
      zendesk: 'Zendesk',
      joget: 'Joget',
      firmao: 'Firmao',
      kylas: 'Kylas',
      close: '关闭',
      firstpromoter: 'Firstpromoter',
      zingtree: 'Zingtree',
      liveagent: 'Liveagent',
      ontraport: 'Ontraport',
      frontapp: 'Frontapp',
      webhoper: 'Webhoper',
      engagebay: 'Engagebay',
      helpshift: 'Helpshift',
      copper: 'Copper',
      autopilot: 'Autopilot',
      flowlu: 'Flowlu',
      freshdesk: 'Freshdesk',
      salesflare: 'Salesflare',
      teamgate: 'Teamgate',
      shipway: 'Shipway',
      googleSheets: 'Google Sheets',
      googleCalendar: 'Google Calendar',
      googleAnalytics: 'Google Analytics',
      supportTicketingSystem: '支持票务系统',
      zapier: 'Zapier',
      pabbly: 'Pabbly',
      hubSpot: 'HubSpot',
      gitHub: 'GitHub',
      salesforce: 'Salesforce',
      inChatAudioAndVideoCall: '聊天中的音频和视频通话（Twilio/Agora）',
      courierTracking: '快递跟踪',
      emailIntegration: '邮件集成',
      webhooks: 'Webhooks',
      schedulers: '计划程序',
      paymentGateways: '支付网关（Stripe和RazorPay）',
      enterpriseIntegrations: '企业集成',
      customIntegration: '自定义集成',
      shopifyIntegration: 'Shopify集成',
      totalNumberOfMessages: '消息总数',
      totalNumberOfLeads: '潜在客户总数',
      weeklyReportBotwise: '每周报告，按机器人分类',
      averageAgentResponeTime: '平均坐席响应时间',
      visitorTimingReport: '访客定时报告',
      customerSegmentBasedReports: '基于客户段的报告',
      tagBasedReports: '基于标签的报告',
      leadGenerationReport: '潜在客户生成报告',
      supportOnWhatsApp: '在WhatsApp上的支持',
      knowledgeBase: '知识库',
      onboardingAndTraining: '入职培训',
      callAndEmailSupport: '电话和邮件支持',
      freeChatbotCreation: '免费聊天机器人创建',
      customerSuccessOfficer: '客户成功官员',
      secureConnection2048BitSSL: '2048位SSL安全连接',
      securityAssessment: '安全评估',
      dataCenterInUSOrEU: '数据中心位于美国或欧盟',
      twoStepVerification: '两步验证',
      accessRestrictionsBasedOnIPs: '基于IP的访问限制',
      onDemandAuditLog: '按需审计日志',
      bannedVisitorsList: '被禁访客列表',
      customAPIRate: '自定义API速率',
      trustedDomains: '受信任的域',
      mb100: '100 MB',
      gb1: '1 GB',
      codingCurious: '编码好奇者',
    },
    appTooltip: {
      TOOLTIP_BABY_PLAN: '我们的免费计划',
      TOOLTIP_KING_PLAN: '我们最受欢迎的计划',
      TOOLTIP_EMPEROR_PLAN: '定制计划，无限消息，无限数据，无限团队成员',
      TOOLTIP_CONTACT_US: '通过WhatsApp或电子邮件（contact@botpenguin.com）与我们联系，了解更多关于我们定制计划的信息',
      TOOLTIP_UPGRADE: '升级您当前的计划以获得额外功能',
      TOOLTIP_MONTHLY: '选择每月支付周期',
      TOOLTIP_YEARLY: '选择每年支付周期以享受折扣优惠',
    }
  },
  whatsappPlans: {
    goToBabyPlan: '切换到免费计划',
    freeForever: '永久免费',
    features: '功能',
    currentPlan: '当前计划',
    changePlan: '更改计划',
    currentlyActive: '当前生效',
    seeHowToUse: '查看如何使用',
    weHaveGotPricingPerfectForYou: '我们为您提供了完美的定价计划',
    weBelieve: '我们相信',
    shouldBeAccessibleToAllCompanies: ' 应该对所有公司都可访问，无论其规模如何。',
    monthly: '每月',
    yearly: '每年',
    twoMonthsFree: '(2个月免费)',
    kingPlan: '王者计划',
    perYear: '每年',
    perMonth: '每月',
    conversationsPerMonth: '每月对话次数',
    upgradePlan: '升级计划',
    emperorPlan: '帝王计划（企业版）',
    haveAsManyConversationsAsYouNeed: '有尽可能多的对话',
    contactUs: '联系我们',
    metaConversationChargesAreAdditional: '元对话费用是额外的，并由您直接支付给Meta，根据您的使用情况。我们不收取任何涨价费用或中介费。',
    viewDetailedPricing: '查看详细定价',
    conversationPricingModelUsedByMeta: 'Meta使用的对话定价模型',
    whatsappBusinessPlatformConversationsFallInto: 'WhatsApp Business Platform的对话分为两类，其定价不同',
    userInitiatedConversation: '用户发起的对话',
    userInitiatedConversationDescription: '响应用户消息而启动的对话。每当企业在24小时客户服务窗口内回复用户时，该消息将与用户发起的对话相关联。企业可以在此24小时客户服务窗口内发送自由形式的消息。',
    businessInitiatedConversation: '企业发起的对话',
    businessInitiatedConversationDescription: '在24小时客户服务窗口之外从企业发送消息而启动的对话。启动企业发起的对话的消息将需要使用消息模板。',
    areYouSureYouWantTo: '您确定要从',
    conversations: '对话',
    plan: ' 计划',
    toThe: ' 到',
    metaPricingMarkup: 'Meta定价标记',
    numberOfChatFlows: '聊天流数量',
    greenTickApplication: '绿色对勾应用',
    extraPhoneNumberLinking: '额外的电话号码链接',
    teamMembers: '团队成员',
    dataStorage: '数据存储',
    conditionalFlow: '条件流',
    liveChat: '实时聊天',
    smartInbox: '智能收件箱',
    whatsappTemplates: 'WhatsApp模板',
    customerSegments: '客户群体',
    broadcastAndDripCampaigns: '广播和滴漏活动',
    multipleLanguages: '多种语言',
    bookAppointments: '预约',
    csvContactsExport: 'CSV联系人导出',
    googleCalendarIntegrations: 'Google日历集成',
    nativeApplications: '60多个本机集成',
    whatsappSupport: 'WhatsApp支持',
    emailAndCallSupport: '电子邮件和呼叫支持',
    customerIntegrations: '客户集成',
    nlpAndNluCapabilities: 'NLP和NLU功能',
    chatGPTBot: 'ChatGPT聊天机器人',
    customerSuccessOfficer: '客户成功官员',
    noMarkupTransparency: '无涨价透明度',
    upto500kPerMonth: '每月多达500,000',
    beyond500k: '超过500,000',
    unlimited: '无限',
    unlimitedMessages: '无限消息',
    oneTeamMember: '1团队成员',
    unlimitedTeamMember: '无限团队成员',
    nintyDaysOfDataStorage: '90天的数据存储',
    unlimitedDataStorage: '无限数据存储',
    downgradeToFreePlan: '降级到免费计划',
    detailedPricing: {
      onDemandAuditLog: '按需审核日志',
      accessRestrictionsBasedOnIPs: '基于IP的访问限制',
      averageAgentResponeTime: '平均代理响应时间',
      perMonth100: '每月100',
      solutionType: '解决方案类型',
      saas: 'SaaS',
      saasOnPremises: 'SaaS On Premises',
      emperorPlan: '帝王计划',
      babyPlan: '免费计划',
      kingsplan: '王者计划',
      braodcastsAndDrips: '广播和滴漏',
      thirtyDays: '30天',
      ninetyDays: '90天',
      oneMember: '1团队成员',
      threeMembers: '3团队成员',
      one: '1（一个）',
      unlimitedMessages: '无限消息',
      unlimitedBots: '无限机器人',
      messagesSend: '发送消息',
      upto500000perMonth: '每月多达500,000',
      unlimited: '无限',
      onlyAdmin: '仅管理员',
      mb100: '100 MB',
      gb1: '1 GB',
      doItYourself: '自己动手',
      weAreHereToHelp: '我们在这里帮助您',
      weTakeCareEndToEnd: '我们全程照顾',
      numberOfBots: '机器人数量',
      conversations: '对话',
      gptMessages: 'GPT消息',
      whatsappNumbers: 'WhatsApp号码',
      subscribersLeads: '订阅者/潜在客户',
      createSupportTeamForLiveChat: '创建实时聊天支持团队',
      conversationHistory: '对话历史',
      chatbotDesigning: '聊天机器人设计',
      multipleLanguages: '多语言',
      conditionalFlow: '条件流',
      whatsappTemplates: 'WhatsApp模板',
      restartChatFlowTriggers: '重启聊天流触发器',
      multipleWhatsAppWidgets: '多个WhatsApp小部件',
      importWhatsappContacts: '导入WhatsApp联系人',
      whatsappQuickReply: 'WhatsApp快速回复',
      whatsappSmartInbox: 'WhatsApp智能收件箱',
      whatsappEcommerceCatalogs: 'WhatsApp电子商务与目录',
      whatsappBroadcast: 'WhatsApp广播',
      whatsappBroadcastAnalytics: 'WhatsApp广播分析',
      dripCampaigns: '滴灌活动',
      customerSegmentation: '客户分割',
      keywordBasedResponse: '基于关键字的响应',
      whatsappShopManagement: 'WhatsApp商店管理',
      aiChatbot: 'AI聊天机器人',
      chatGPTIntegration: 'ChatGPT集成',
      configureAIChatbotPersonality: '配置AI聊天机器人个性',
      trainChatbotOnYourOwnData: '在您自己的数据上训练聊天机器人',
      trainChatbotOnWebPages: '在网页上训练聊天机器人',
      trainChatbotOnMultipleFiles: '在多个文件上训练聊天机器人',
      trainChatbotOnFAQs: '在FAQ上训练聊天机器人',
      dataTrainingStorage: '数据训练存储',
      useChatGPTModel4or35Turbo: '使用ChatGPT Model 4/3.5 Turbo',
      uploadMultipleFilesForChatbotTraining: '上传多个文件进行聊天机器人培训',
      naturalLanguageProcessing: '自然语言处理',
      naturalLanguageUnderstanding: '自然语言理解',
      answerLength: '回答长度',
      chatTone: '聊天语气',
      multiLanguage: '多语言',
      answerFormatting: '回答格式',
      customPrompt: '自定义提示',
      whatsAppSessionManagement: 'WhatsApp会话管理（不活动和流重启消息）',
      integrateBotPenguinLLM: '集成BotPenguin LLM',
      integrateOwnCustomLLM: '集成自己/定制LLM',
      periodicallySyncDataSources: '定期同步数据源',
      aiBasedSuggestedQuestions: '基于AI的建议问题',
      chooseVisibilityForParticularWebpageSitemap: '为特定网页/站点地图选择可见性',
      chooseKnowledgeMix: '选择知识混合：您的知识库ChatGPT知识 "ChatGPT知识 + 您的知识库"',
      faqExtractionFromFileAndURL: '从文件和URL提取FAQ',
      analyticsToImproveAI: '改善AI的分析',
      exportQuestionFlow: '导出问题流',
      collectFeedbackOnChatbotResponses: '收集聊天机器人响应的反馈',
      smartAIFollowUpQuestions: '智能/AI后续问题',
      trainOnYourNotionWorkspaceData: '在您的Notion工作区数据上进行培训',
      trainOnYoutubeVideo: '在Youtube视频上训练',
      trainOnCustomVideoUpload: '在自定义视频上传上训练',
      rssFeed: 'RSS订阅',
      googleDrive: 'Google云盘',
      dropBox: 'DropBox',
      humanHandover: '人工交接',
      botHandover: '机器人交接',
      handoverBetweenAgents: '代理之间的交接',
      emailAndMobileValidation: '电子邮件和手机验证',
      mobileAppsForAgents: '代理的移动应用程序',
      appointmentBooking: '预约预订',
      roleBasedAccessControls: '基于角色的访问控制',
      ruleBasedChatRouting: '基于规则的聊天路由',
      liveVisitorsDetails: '实时访客详情',
      multipleSimultaneousChats: '多个同时聊天',
      visitorStats: '访客统计',
      addContactsFromWhatsApp: '从WhatsApp添加联系人',
      applyFilterAndSortConversations: '应用筛选器和排序对话',
      seeChatLogs: '查看聊天记录',
      quickReplies: '快速回复',
      unifiedCustomerProfile: '统一客户资料',
      assignNotesAndChatTags: '分配注释和聊天标签',
      exportLeadsInCSV: '以CSV格式导出潜在客户',
      tagContacts: '标记联系人',
      customAttributes: '自定义属性',
      markStatusOfConversations: '标记对话状态',
      assignConversationToAgents: '分配对话给代理',
      leadNotificationsByEmail: '通过电子邮件发送潜在客户通知',
      directCallsToLeadsWithTwilio: '使用Twilio直接呼叫潜在客户',
      whatsAppTemplates: 'WhatsApp模板',
      promotionalMessageFrequencyControl: '促销消息频率控制',
      whatsAppWidget: 'WhatsApp小部件',
      whatsAppQR: 'WhatsApp二维码',
      whatsAppLink: 'WhatsApp链接',
      campaignScheduler: '活动计划程序',
      customTriggers: '自定义触发器',
      customCampaigns: '自定义活动',
      repeatPurchaseReminders: '重复购买提醒',
      campaignOpenRateTracking: '活动开放率跟踪',
      paymentCollectionOnWhatsApp: '在WhatsApp上收款',
      agileCRM: 'Agile CRM',
      capsule: 'Capsule',
      insightly: 'Insightly',
      nimble: 'Nimble',
      leadsquared: 'Leadsquared',
      chakra: 'Chakra',
      plivo: 'Plivo',
      helpcrunch: 'Helpcrunch',
      getresponse: 'Getresponse',
      supportbee: 'Supportbee',
      pipeline: 'Pipeline',
      zendesk: 'Zendesk',
      joget: 'Joget',
      firmao: 'Firmao',
      kylas: 'Kylas',
      close: 'Close',
      firstpromoter: 'Firstpromoter',
      zingtree: 'Zingtree',
      liveagent: 'Liveagent',
      ontraport: 'Ontraport',
      frontapp: 'Frontapp',
      webhoper: 'Webhoper',
      engagebay: 'Engagebay',
      helpshift: 'Helpshift',
      copper: 'Copper',
      autopilot: 'Autopilot',
      flowlu: 'Flowlu',
      freshdesk: 'Freshdesk',
      salesflare: 'Salesflare',
      teamgate: 'Teamgate',
      shipway: 'Shipway',
      googleSheets: 'Google表格',
      googleCalendar: 'Google日历',
      googleAnalytics: 'Google Analytics',
      supportTicketingSystem: '支持工单系统',
      zapier: 'Zapier',
      pabbly: 'Pabbly',
      hubSpot: 'HubSpot',
      gitHub: 'GitHub',
      salesforce: 'Salesforce',
      inChatAudioAndVideoCall: '聊天中的音频和视频通话（Twilio/Agora）',
      courierTracking: '快递追踪',
      emailIntegration: '电子邮件集成',
      webhooks: 'Webhooks',
      schedulers: '调度程序',
      paymentGateways: '支付网关（Stripe和RazorPay）',
      enterpriseIntegrations: '企业集成',
      customIntegration: '自定义集成',
      freeWhatsAppAPIApprovalAndSetup: '免费WhatsApp API批准和设置',
      developerAPIsAccess: '开发者API访问',
      customRateLimit: '自定义速率限制',
      totalNumberOfLeads: '潜在客户总数',
      averageAgentResponseTime: '平均代理响应时间',
      visitorTimingReport: '访客定时报告',
      customerSegmentBasedReports: '基于客户段的报告',
      tagBasedReports: '基于标签的报告',
      leadGenerationReport: '潜在客户生成报告',
      supportOnWhatsApp: '在WhatsApp上的支持',
      knowledgeBase: '知识库',
      onboardingAndTraining: '入职和培训',
      callAndEmailSupport: '电话和电子邮件支持',
      freeChatbotCreation: '免费聊天机器人创建',
      customerSuccessOfficer: '客户成功官员',
      secureConnection: '2048位SSL安全连接',
      securityAssessment: '安全评估',
      dataCenterLocation: '数据中心位于美国或欧盟',
      twoStepVerification: '两步验证',
      accessRestrictions: '基于IP的访问限制',
      auditLog: '按需审计日志',
      bannedVisitorsList: '被禁访客名单',
      customAPIRate: '自定义API速率',
      trustedDomains: '受信任的域',
      elementary: '初级',
      bots: '机器人',
      unlockWhatsapp: '解锁WhatsApp',
      aiChatbotFeatures: 'AI聊天机器人功能',
      dataSourceForTraining: '培训数据源',
      smartFeatures: '智能功能',
      liveChat: '实时聊天',
      smartInbox: '智能收件箱',
      broadcastsAndDrips: '广播和滴灌',
      integrations: '集成',
      development: '开发',
      reportsAndAnalytics: '报告和分析',
      customerSupport: '客户支持',
      security: '安全',
      whatsappWidgets: 'WhatsApp小部件',
      campaignSchedular: '活动计划程序',
      repeatPurchaseRemainder: '重复购买提醒',
      // metaConversationChargesAreAdditional: 'Meta conversation charges are additional and paid directly by you to Meta, based on' +
      //   ' your usage. We do not charge any markup or facilitation fees.',
      // kingPlan: 'King Plan',
      // emperorPlan: 'Emperor Plan',
      // solutionType: 'Solution Type',
      // whatsappTemplates: 'WhatsApp Templates',
      // dripCampaigns: 'Drip campaigns',
      // multipleWhatsappWidgets: 'Multiple WhatsApp Widgets',
      // importWhatsappContacts: 'Import Whatsapp Contacts',
      // whatsappQuickReply: 'WhatsApp Quick reply',
      // whatsappSmartInbox: 'WhatsApp Smart Inbox',
      // whatsappECommerceWithCatalogs: 'WhatsApp E-commerce with Catalogs',
      // whatsappBroadcast: 'WhatsApp Broadcast',
      // whatsappBroadcastAnalytics: 'WhatsApp Broadcast Analytics',
      // customerSegmentation: 'Customer Grouping',
      // keywordBasedResponse: 'Keyword Based Response',
      // nlpBasedTraining: 'NLP Based Training',
      // humanHandOver: 'Human Handover',
      // botHandOver: 'Bot Handover',
      // handOverBetweenAgents: 'Handover between Agents',
      // emailAndMobileValidation: 'Email and Mobile Validation',
      // mobileAppsForAgents: 'Mobile Apps for Agents',
      // appointmentsBooking: 'Appointments Booking',
      // chatGPTIntegration: 'ChatGPT integration',
      // faqTraining: 'FAQ Training',
      // naturalLanguageProcessing: 'Natural Language Processing',
      // naturalLanguageUnderstanding: 'Natural Language Understanding',
      // roleBasedAccessControl: 'Role-based Access Controls',
      // liveVisitorsDetails: 'Live Visitors details',
      // multipleSimultaneousChats: 'Multiple simultanaeous chats',
      // ruleBasedChatRouting: 'Rule based Chat Routing',
      // createSupportTeamForLiveChat: 'Create Support Team for Live chat',
      // visitorStats: 'Visitor stats',
      // addContactsFromWhatsapp: 'Add Contacts from Whatsapp',
      // applyFilterAndSortConversation: 'Apply filter and sort conversations',
      // seeChatLogos: 'See chat logs',
      // directCallToLeads: 'Direct Calls-to-leads (with Twilio)',
      // quickReplies: 'Quick Replies',
      // unifiedCustomerProfile: 'Unified Customer Profile',
      // assignNotesAndChatTags: 'Assign Notes and Chat Tags',
      // exportLeadsInCsv: 'Export Leads in CSV',
      // leadNotificationsByEmail: 'Lead Notifications by email',
      // promotionalMessageFrequencyControl: 'Promotional Message Frequency Control',
      // repeatPurchaseRemainder: 'Repeat Purchase Reminders',
      // whatsappWidgets: 'WhatsApp Widget',
      // whatsappQR: 'WhatsApp QR',
      // whatsappLink: 'WhatsApp Link',
      // campaignSchedular: 'Campaign Scheduler',
      // campaignOpenRateTracking: 'Campaign Open Rate Tracking',
      // customTriggers: 'Custom Triggers',
      // customCampaigns: 'Custom Campaigns',
      // paymentCollectionOnWhatsapp: 'Payment Collection On WhatsApp',
      // zapier: 'Zapier',
      // crmIntegrations: 'CRM Integrations (25+)',
      // supportTicketingSystem: 'Support Ticketing System',
      // googleSheets: 'Google Sheets',
      // inChatAudioAndVideo: 'In-chat audio and video call',
      // googleCalendar: 'Google Calendar',
      // googleAnalytics: 'Google Analytics',
      // emailIntegration: 'Email Integration',
      // courierTracking: 'Courier Tracking',
      // webhooks: 'Webhooks',
      // paymentGateways: 'Payment Gateways',
      // hubspot: 'HubSpot ',
      // gitHub: 'GitHub ',
      // zendesk: 'Zendesk',
      // salesforce: 'Salesforce',
      // customIntegrations: 'Custom Integrations',
      // developerApisAccess: 'Developer APIs access',
      // customRateLimit: 'Custom Rate Limit ',
      // totalNumberOfLeads: 'Total Number of Leads',
      // averageAgentResponseTime: 'Average agent respone time',
      // visitorTimingReport: 'Visitor Timing Report',
      // customerSemgentBasedReport: 'Customer Group-based Reports',
      // tagBasedReport: 'Tag-based Reports',
      // leadGenerationReport: 'Lead Generation Report',
      // supportOnWhatsapp: 'Support on WhatsApp',
      // knowledgeBase: 'Knowledge Base',
      // onboardingAndTraining: 'Onboarding and Training',
      // callAndEmailSupport: 'Call and Email Support',
      // freeChatBotCreation: 'FREE chatbot creation',
      // elementary: 'Elementary',
      // smartFeatures: 'Smart Features',
      // liveChat: 'Live Chat',
      // smartInbox: 'Smart Inbox',
      // broadcastsAndDrips: 'Broadcasts & Drips',
      // integrations: 'Integrations',
      // development: 'Development',
      // reportsAndAnalytics: 'Reports and Analytics',
      // customerSupport: 'Customer Support',
      // unlockWhatsapp: 'Unlock WhatsApp',
      // saas: 'SaaS',
      // saasOnPremises: 'SaaS/On-Premises',
      // customerFaqs: `Custom FAQ's`,
      // oneMember: '1 member',
      // beWhereTheCustomersAre: 'Be where the customers are',
      // lifesEasy: 'Life\'s easy',
      // oneTextAway: 'One text away',
      // everyWhereAtOnce: 'Everywhere at Once',
      // reachOut: 'Reach Out',
      // morePowerToYou: 'More power to you',
      // codingCurious: 'Coding Curious',
      // knowledgeIsPower: 'Knowledge is power',
      // noDoubtsRemain: 'No doubts remain',
    },
    appTooltip: {
      TOOLTIP_BABY_PLAN: '我们的免费计划',
      TOOLTIP_KING_PLAN: '我们最受欢迎的计划',
      TOOLTIP_EMPEROR_PLAN: '定制计划，无限消息，无限数据，无限团队成员',
      TOOLTIP_CONTACT_US: '通过WhatsApp或电子邮件contact@botpenguin.com与我们联系，了解更多关于我们定制计划的信息',
      TOOLTIP_UPGRADE: '升级您当前的计划以获得额外功能',
      TOOLTIP_MONTHLY: '选择每月付款周期',
      TOOLTIP_YEARLY: '选择每年付款周期以享受折扣优惠',
    }
  }
};
